import { referralApi } from '@api/index';
import { usePaginationQuery } from '@hooks/usePaginationQuery';
import { QUERIES } from '@query/queries';

export const useReferralsCodes = () => {
  return usePaginationQuery([QUERIES.REFERRALS_CODES], (query) => referralApi.getCodes(query));
};
